/**
 * Phase 8 T-06b §20.C · Action chips below each assistant turn.
 *
 * 2–4 emerald outline pills, 11 px text. Contextual to the assistant reply.
 */

import type { AgentActionChip } from '../hooks/useAgentThread';

interface Props {
  chips: AgentActionChip[];
  /** Click handler used when a chip has no own onClick (e.g. empty-state chips). */
  onChipClick?: (chip: AgentActionChip) => void;
}

export function AgentActionChips({ chips, onChipClick }: Props) {
  if (!chips.length) return null;
  return (
    <div className="mt-2 flex flex-wrap items-center gap-1.5">
      {chips.map((c) => (
        <button
          key={c.id}
          type="button"
          onClick={() => {
            if (c.onClick) c.onClick();
            else onChipClick?.(c);
          }}
          className="inline-flex h-6 items-center rounded-[10px] border px-2.5 text-[11px] font-medium transition-colors"
          style={{
            borderColor: 'color-mix(in srgb, var(--ggj-accent,#10B981) 35%, var(--vscode-border-primary))',
            color: 'var(--ggj-accent,#10B981)',
            background: 'transparent',
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = 'var(--ggj-accent-soft,#D1FAE5)')
          }
          onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
        >
          {c.label}
        </button>
      ))}
    </div>
  );
}
